import React, { useEffect, useState } from "react";
import { isDacimal } from "../../../../../Containers/vendor/DashBoard/DBCosntants";
import { IListObj } from "../../../../types/genericTypes";
import ColoumnsHeader from "../../generic/ColoumnsHeader";
import NoDataFound from "../../generic/NoDataFound";
import { VolumeSegmentsOptions, TopLeadersImg } from "../../utlits";
export interface IVS_TopLeaderProps {
  topLeaders: any;
  leadersdropdownValue: string;
  setLeadersdropdownValue: (val: string) => void;
}

const VS_TopLeader: React.FC<IVS_TopLeaderProps> = (props) => {
  const [topLeaders, setTopLeaders] = useState<any>([]);
  const [ldrsDropdownOptions, setLdrsDropdownOptions] = useState<
    Array<IListObj>
  >([{ display: "Total", value: "Total" }, ...VolumeSegmentsOptions]);

  const [disableMenu, setDisableMenu] = useState<boolean>(false);

  useEffect(() => {
    if (props.topLeaders.length > 0) {
      setDisableMenu(false);
      let arrangLdrsData: any = [];
      props.topLeaders.forEach((value: any, i: number) => {
        let ldrsData: any = {};
        ldrsData.acCd = value.acCd;
        ldrsData.img = TopLeadersImg[i];
        value.vol.forEach((vol: any) => {
          ldrsData[vol.key] = vol.val;
        });
        arrangLdrsData.push(ldrsData);
      });
      if (arrangLdrsData.length > 0) {
        setTopLeaders([...arrangLdrsData]);
      }
    } else {
      setDisableMenu(true);
      setTopLeaders([]);
    }
  }, [props.topLeaders]);

  return (
    <div className="top_leaders_container">
      <ColoumnsHeader
        title={"Top Volume Leaders"}
        isDropdown={true}
        isDownload={false}
        dropdownOptions={ldrsDropdownOptions}
        dropdownValue={props.leadersdropdownValue}
        setDropdownValue={props.setLeadersdropdownValue}
        disableMenu={disableMenu}
        hints={"All Values in CR."}
      />
      {disableMenu ? (
        <NoDataFound />
      ) : (
        <>
          <table className="top_leaders deshtop_table ">
            <thead className="">
              <tr>
                <th>Account</th>
                <th>Total</th>
                <th>Cash</th>
                <th>Derivatives</th>
                <th>Currency</th>
                {/* <th>Commodity</th> */}
              </tr>
            </thead>
            <tbody>
              {topLeaders &&
                topLeaders.map((leader: any, i: string) => {
                  return (
                    <tr key={i}>
                      <td>
                        <img src={leader.img} alt={leader.img} />
                        <span className="account_code">{leader.acCd}</span>
                      </td>
                      <td>
                        <span className="rupee_symbol">₹</span>
                        {isDacimal(leader.Total)}
                      </td>
                      <td>{isDacimal(leader.Cash)}</td>
                      <td>{isDacimal(leader.Derivatives)}</td>
                      <td>{isDacimal(leader.Currency)}</td>
                      {/* <td>{leader.Commodity}</td> */}
                    </tr>
                  );
                })}
            </tbody>
          </table>
          <table className="top_leaders mob_table">
            <thead className="">
              <tr>
                <th>Account/Total</th>
                <th>Cash</th>
                <th>Derivatives</th>
                <th>Currency</th>
                {/* <th>Commodity</th> */}
                {/* <th>Deriva..</th>
            <th>Currency</th>
            <th>Comm.</th> */}
              </tr>
            </thead>
            <tbody>
              {topLeaders &&
                topLeaders.map((leader: any, i: number) => {
                  return (
                    <tr key={i}>
                      <td>
                        <img src={leader.img} alt={leader.img} />
                        <span>
                          <p className="account_code">{leader.acCd}</p>
                          <p>
                            <span className="rupee_symbol">₹</span>
                            {isDacimal(leader.Total)}
                          </p>
                        </span>
                      </td>
                      <td>{isDacimal(leader.Cash)}</td>
                      <td>{isDacimal(leader.Derivatives)}</td>
                      <td>{isDacimal(leader.Currency)}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};

export default VS_TopLeader;
